import React, { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import axiosConfig from "../../axiosConfig";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import AutoComplete from "@material-ui/lab/Autocomplete";
import Swal from "sweetalert2";
import { useFormik } from "formik";
import * as Yup from "yup";
import Loading from "../Loading/loading";
import axios from "axios";
import GetUser from "../../services/auth.getUser";
import { useHistory } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  makeStyles,
} from "@material-ui/core";
import {
  Card as Card2,
  CardHeader as CardHeader2,
  CardBody,
} from "../../shared/Card/Index";
import styles from "../../shared/dashboardStyle";
import * as headers from "../../shared/language.json";
import * as regEx from "../../shared/regularExpressions";
import { swalSubmit } from "../../shared/swalSubmit";

const useStyles = makeStyles(styles);

function CreateManagementUser() {
  const [roles, setRoles] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const classes = useStyles();
  const history = useHistory();
  const getTheUser = GetUser();

  const currentUserEmail = jwt_decode(getTheUser.accessToken);

  useEffect(() => {
    const promise1 = axiosConfig.get(`/Role`);

    axios
      .all([promise1])
      .then(
        axios.spread((...res) => {
          const responseOne = res[0];
          setRoles(responseOne.data);

          setLoading(false);
        })
      )
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleSubmit = () => {
    let email = formik.values.email;
    axiosConfig.post(
      `/User/SendTemporaryPassword/${currentUserEmail.Username}`,
      null,
      {
        params: {
          email,
        },
      }
    );
  };

  const formik = useFormik({
    initialValues: {
      firstname: "",
      lastname: "",
      email: "",
      roleId: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .matches(regEx.email, headers.FORMIKERRORMESSAGES.INVALIDEMAIL)
        .required(headers.FORMIKERRORMESSAGES.REQUIRED),
      firstname: Yup.string()
        .matches(
          regEx.nameRegexGreekOnly,
          headers.FORMIKERRORMESSAGES.GREEKONLYANDFIRSTLETTERCAPITAL
        )
        .min(3, headers.FORMIKERRORMESSAGES.ATLEASTTHREECHARACTERS)
        .max(30, headers.FORMIKERRORMESSAGES.THIRTYCHARACTERSMAX)
        .required(headers.FORMIKERRORMESSAGES.REQUIRED),
      lastname: Yup.string()
        .matches(
          regEx.nameRegexGreekOnly,
          headers.FORMIKERRORMESSAGES.GREEKONLYANDFIRSTLETTERCAPITAL
        )
        .min(3, headers.FORMIKERRORMESSAGES.ATLEASTTHREECHARACTERS)
        .max(30, headers.FORMIKERRORMESSAGES.THIRTYCHARACTERSMAX)
        .required(headers.FORMIKERRORMESSAGES.REQUIRED),

      roleId: Yup.string().required(headers.FORMIKERRORMESSAGES.REQUIRED),
    }),

    onSubmit: (values) => {
      Swal.fire({
        title: "",
        text: "Έχετε επιλέξει να δημιουργήσετε νέο χειριστή στο σύστημα. Είστε βέβαιοι;",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ναι",
        cancelButtonText: "Οχι",
        showLoaderOnConfirm: true,
        closeOnClickOutside: false,
        preConfirm: () => {
          Swal.fire(swalSubmit)
            .then((result) => {
              if (result.isConfirmed) {
                return axiosConfig
                  .post("/User/CreateUser", values)
                  .then((response) => {
                    if (response.status === 200) {
                      setOpen(true);
                      history.push("/all-users");
                    }
                  }).catch(() => { Swal.fire("Το E-mail αυτό είναι ήδη καταχωρημένο στη λίστα σας.<br/> Η καταχώρηση δεν μπορεί να πραγματοποιηθεί.", "", "error"); })
              }
            })
        },
        allowOutsideClick: () => !Swal.isLoading(),
      });
    },
  });

  if (loading === false) {
    return (
      <form className="Form">
        {/* <Container maxWidth="lg"> */}
        <Card2>
          <CardHeader2 color="warning">
            <h1 className={classes.cardTitleWhite}>Δημιουργία Χειριστή</h1>
          </CardHeader2>
          <CardBody>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12}>
                <Box mt={3}>
                  <Card>
                    <CardHeader title="" />
                    <Divider />
                    <CardContent>
                      <Grid container spacing={6} wrap="wrap">
                        <Grid item xs={12} sm={12} md={6}>
                          <TextField
                            type="email"
                            required
                            id="email"
                            name="email"
                            label="Email"
                            variant="outlined"
                            fullWidth
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.email}
                          />
                          {formik.touched.email && formik.errors.email ? (
                            <span style={{ color: "red" }}>
                              {formik.errors.email}
                            </span>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <TextField
                            id="firstname"
                            name="firstname"
                            required
                            label="Όνομα"
                            type="text"
                            variant="outlined"
                            fullWidth
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.firstname}
                          />
                          {formik.touched.firstname &&
                            formik.errors.firstname ? (
                            <span style={{ color: "red" }}>
                              {formik.errors.firstname}
                            </span>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <TextField
                            id="lastname"
                            name="lastname"
                            required
                            label="Επώνυμο"
                            type="text"
                            variant="outlined"
                            fullWidth
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.lastname}
                          />
                          {formik.touched.lastname && formik.errors.lastname ? (
                            <span style={{ color: "red" }}>
                              {formik.errors.lastname}
                            </span>
                          ) : null}
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <AutoComplete
                            onChange={(event, newValue) => {
                              if (newValue === null) {
                                formik.setFieldValue("roleId", "");
                              } else {
                                formik.setFieldValue("roleId", newValue.id);
                              }
                            }}
                            options={roles}
                            getOptionLabel={(option) => option.description}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Ρόλος . . ."
                                variant="outlined"
                              />
                            )}
                          />
                          {formik.touched.roleId && formik.errors.roleId ? (
                            <span style={{ color: "red" }}>
                              {formik.errors.roleId}
                            </span>
                          ) : null}
                        </Grid>
                      </Grid>
                    </CardContent>
                    <Divider />
                    <Box display="flex" justifyContent="flex-end" p={2}>
                      {open ? (
                        <Button
                          type="button"
                          variant="contained"
                          color="primary"
                          style={{ marginRight: "1vw" }}
                          onClick={handleSubmit}
                        >
                          Προσωρινος Κωδικος
                        </Button>
                      ) : null}
                      <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={formik.handleSubmit}
                      >
                        Αποθηκευση
                      </Button>
                    </Box>
                  </Card>
                </Box>
              </Grid>
            </Grid>
          </CardBody>
        </Card2>
      </form>
    );
  } else {
    return <Loading />;
  }
}

export default CreateManagementUser;
